import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../mock';
import { Shield, FileText, Lightbulb, Building, ArrowRight } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';

const iconComponents = {
  Shield,
  FileText,
  Lightbulb,
  Building
};

const ServicesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#FFB400] uppercase tracking-wide mb-2">
            OUR SERVICES
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2B0A12] mb-4">
            Complete IP Protection Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From trademark registration to patent filings, we provide comprehensive legal services to protect every aspect of your intellectual property.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = iconComponents[service.icon];
            return (
              <Card
                key={service.id}
                className="group relative overflow-hidden bg-white hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-[#D72638]"
              >
                <div className="p-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#FFB400] to-[#D72638] rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="h-8 w-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-[#2B0A12] mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {service.description}
                  </p>
                  <Link to={service.link}>
                    <Button
                      variant="ghost"
                      className="text-[#D72638] hover:text-[#FFB400] p-0 h-auto font-semibold group/btn"
                    >
                      Learn More
                      <ArrowRight className="ml-2 h-4 w-4 group-hover/btn:translate-x-1 transition-transform" />
                    </Button>
                  </Link>
                </div>
                {/* Hover Effect */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#FFB400] to-[#D72638] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;